export default "__VITE_ASSET__Dbd2eEX5__"